import React, { Component } from 'react';
import './App.css';
import { Provider } from 'react-redux';
import store from './store/rootStore';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Form from './Views/Form';
import Verify from './Views/Verify';
import Toolbar from '@mui/material/Toolbar';
import FormError from './Views/FormError';
import { ThemeProvider, StyledEngineProvider } from '@mui/material';
import importedTheme from './theme';

// form preview
import FormPreview from './Views/FormPreviews/FormPreview';
import BulkAssessment from './Views/BulkAssessment/BulkAssessment';
import { Amplify } from 'aws-amplify';
import { cognitoUserPoolsTokenProvider } from 'aws-amplify/auth/cognito';
import { CookieStorage } from 'aws-amplify/utils';
import awsconfigGG, { currentDomain } from './auth/awsConfig';
import FormWaiting from './Views/FormWaiting';

// Configure Amplify with the same cookie storage as parent app for session sharing
Amplify.configure(awsconfigGG);

// Configure cookie storage to match parent app - this enables automatic session sharing
cognitoUserPoolsTokenProvider.setKeyValueStorage(
  new CookieStorage({
    domain: currentDomain,
    sameSite: 'none',
    secure: true,
    path: '/',
  })
);

// Use the imported theme directly
const customTheme = importedTheme;

class App extends Component {
  createAppBar = () => {
    return (
      <nav
        id="main-header"
        style={{ zIndex: '-100', position: 'unset' }}
        className="navbar navbar-expand-lg navbar-light fixed-top text-right "
      >
        <div
          className="container"
          style={{ maxWidth: 1500, textAlign: 'right' }}
        >
          <a className="navbar-brand" href="https://www.workflow86.com/">
            <img src="/images/w86_logo.png" width="40" alt="" />
          </a>
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav ml-auto"></ul>
          </div>
        </div>
      </nav>
    );
  };

  createFooter = () => {
    return (
      <div className="footer" style={{ backgroundColor: 'rgb(44,44,44)' }}>
        <Toolbar></Toolbar>
      </div>
    );
  };

  render() {
    return (
      <ThemeProvider theme={customTheme}>
        <StyledEngineProvider injectFirst>
          <Provider store={store}>
            <Router
              future={{
                v7_startTransition: true,
                v7_relativeSplatPath: true,
              }}
            >
              <Routes>
                <Route path="/" element={<Verify />} />
                <Route
                  path="/form/form_test/:form_id/:test_id/:session_id"
                  element={<Form />}
                />
                <Route
                  path="/form/form_test/:form_id/:test_id"
                  element={<Form />}
                />
                <Route
                  path="/form/form_preview/:form_id/:projectVersion/:session_id"
                  element={<FormPreview />}
                />
                <Route
                  path="/form/form_preview/:form_id/:projectVersion"
                  element={<Form />}
                />
                <Route
                  path="/form/:form_id/:session_id/:project_session_id"
                  element={<FormWaiting isTest={false} />}
                />
                <Route
                  path="/form_test/:form_id/:session_id/:project_session_id/:test_id"
                  element={<FormWaiting isTest={true} />}
                />
                <Route path="/form/:form_id/:session_id" element={<Form />} />
                <Route path="/form/:form_id" element={<Form />} />
                <Route path="/form" element={<Verify />} />
                <Route path="/form_error/:error_type" element={<FormError />} />
                <Route path="/form_error" element={<FormError />} />
                <Route
                  path="/bulk/bulk_test/:component_id/:test_id"
                  element={<BulkAssessment />}
                />
                <Route
                  path="/bulk/:component_id"
                  element={<BulkAssessment />}
                />
              </Routes>
            </Router>
          </Provider>
        </StyledEngineProvider>
      </ThemeProvider>
    );
  }
}

export default App;
